// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React, { useState } from "react";

import FullPageLoading from "../components/FullPageLoading";
import { LoadingContext } from "./LoadingContext";

export const LoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  const addLoading = () => {
    setLoading(true);
  };

  const removeLoading = () => {
    setLoading(false);
  };

  return (
    <LoadingContext.Provider value={{ addLoading, removeLoading }}>
      {loading && <FullPageLoading />}
      {children}
    </LoadingContext.Provider>
  );
};
